import React from "react";
import HeroImage from "../assets/images/mission.jpg";
import HeroImage3 from "../assets/images/news.jpg";
import CountryDropdown from "../CountryDropdown";

const MissionPage = () => {
  return (
    <div>
      {/* Purpose of the Website Section */}
      <section
        className="relative py-28 px-4 sm:px-6 text-center bg-cover bg-center"
        style={{ backgroundImage: `url(${HeroImage})` }}
        id="purpose-of-website"
      >
        {/* Tea-colored dark overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-[#3e2c23]/80 to-black/80"></div>

        <div className="relative z-10 max-w-7xl mx-auto text-[#FFF5D1]">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-fortyTwo font-bold mb-6 inline-block pb-2 border-b-4 border-[#A9744F]">
            Purpose of the Website
          </h2>

          <p className="text-lg sm:text-xl md:text-2xl leading-relaxed mb-8 max-w-3xl mx-auto text-[#F3E5AB]">
            What began as a calm, sarcastic phrase by a captured Indian pilot…
            <br />
            has now become a global symbol of Pakistani grace, wit, and
            strategic hospitality.
          </p>

          <p className="text-lg sm:text-xl md:text-2xl leading-relaxed mb-8 max-w-4xl mx-auto text-[#fbeec1]">
            TeaWasFantastic.com is Pakistan’s first meme warfare command —
            created to counter propaganda, spread truth with humor, and showcase
            our cool-headed strength under fire.
          </p>

          <p className="text-lg sm:text-xl md:text-2xl leading-relaxed max-w-4xl mx-auto text-[#FFFADD] mb-10">
            We don’t throw punches.
            <br />
            We pour tea. And we serve it with a smile — and a meme.
          </p>
        </div>
      </section>

      {/* Our Mission Section */}
      <section
        className="py-28 px-4 sm:px-6 mt-24 mb-24 bg-[#3e2c23] text-[#FFF5D1]"
        id="our-mission"
      >
        <div className="max-w-7xl mx-auto">
          {/* Title */}
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-fortyTwo font-bold mb-10 text-center text-[#FBEEC1]">
            Our Mission
          </h2>

          {/* Mission List */}
          <ul className="text-lg sm:text-xl md:text-2xl leading-relaxed space-y-4 max-w-3xl mx-auto mb-14 text-center text-[#FDF6DD]">
            <li>• To counter disinformation through satire</li>
            <li>
              • To unify global Pakistani creatives in humor-based digital
              defense
            </li>
            <li>• To turn memes into messages that move across borders</li>
            <li>• To let the world laugh with us, not at us</li>
          </ul>

          {/* Core Sections Heading */}
          <h3 className="text-3xl sm:text-4xl md:text-5xl font-fortyTwo font-bold mb-10 text-center text-[#A9744F]">
            Core Sections
          </h3>

          {/* Grid Cards */}
          <div className="space-y-16">
            {/* Upload Your Meme */}
            <div className="bg-[#FFF8E1] text-[#2E1C12] p-8 rounded-xl shadow-2xl">
              <h4 className="text-2xl font-semibold mb-4">
                1️⃣ Upload Your Meme
              </h4>
              <p className="text-lg mb-4">
                Are you a meme lord with a message? Create it. Upload it. Strike
                the feed.
              </p>
              <ul className="list-disc list-inside text-lg mb-4">
                <li>• Images</li>
                <li>• GIFs</li>
                <li>• Short videos (up to 60 seconds)</li>
                <li>• Jokes with visual bite</li>
              </ul>
              <div className="text-center">
                <button className="bg-[#B08968] hover:bg-[#A9744F] text-white font-semibold px-8 py-3 rounded shadow-lg transition duration-300">
                  🟢 Submit Your Meme
                </button>
              </div>
            </div>

            {/* Weekly Meme Battles */}
            <div className="bg-[#FAF3E0] text-[#2C1A0F] p-8 rounded-xl shadow-2xl">
              <h4 className="text-2xl font-semibold mb-4">
                2️⃣ Weekly Meme Battles
              </h4>
              <p className="text-lg mb-4">
                Compete in creative wars. Win glory. Every week, we run a global
                meme contest with themes like:
              </p>
              <ul className="list-disc list-inside text-lg mb-4">
                <li>• #TeaWasFantastic</li>
                <li>• #HospitalityStrike</li>
                <li>• #ChaiVsChaos</li>
                <li>• #LaughWithPakistan</li>
              </ul>
              <p className="text-lg mb-4">
                Top memes are featured. Winners get merch and global
                recognition.
              </p>
              <div className="text-center">
                <button className="bg-[#B08968] hover:bg-[#A9744F] text-white font-semibold px-8 py-3 rounded shadow-lg transition duration-300">
                  🟢 Join This Week’s Battle
                </button>
              </div>
            </div>

            {/* Global Guestbook */}
            <div className="bg-[#FFF8E1] text-[#2E1C12] p-8 rounded-xl shadow-2xl">
              <h4 className="text-2xl font-semibold mb-4">
                3️⃣ Global Guestbook
              </h4>
              <p className="text-lg mb-4">
                For the world: Have you ever had chai in a Pakistani home?
                Foreigners from all over are invited to share:
              </p>
              <ul className="list-disc list-inside text-lg mb-4">
                <li>• Photos</li>
                <li>• Stories</li>
                <li>• Videos</li>
              </ul>
              <p className="text-lg mb-4">
                That show Pakistan’s legendary hospitality. This is soft power
                through storytelling.
              </p>
              <div className="text-center">
                <button className="bg-[#B08968] hover:bg-[#A9744F] text-white font-semibold px-8 py-3 rounded shadow-lg transition duration-300">
                  🟢 Share Your Chai Story
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 250+ Country Meme Zones Section */}
      <section
        className="py-28 px-4 sm:px-6 text-center bg-[#FFF8E1]"
        id="country-meme-zones"
      >
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-fortyTwo font-bold text-[#3e2c23] mb-6">
            🌍 250+ Country Meme Zones
          </h2>
          <p className="text-lg sm:text-xl md:text-2xl text-[#4a2d1f] mb-8 max-w-3xl mx-auto">
            We are building dedicated meme zones for every country.
            <br />
            Example:
          </p>

          <div className="bg-[#FAF3E0] p-8 rounded-xl shadow-xl mb-8">
            <p className="text-2xl text-left mb-6 text-[#3d1f0f]">
              Each zone will:
            </p>
            <ul className="list-disc list-inside text-xl sm:text-2xl text-left mb-10 text-[#4a2d1f] space-y-2">
              <li>Feature country-specific memes</li>
              <li>Host local contests</li>
              <li>Recruit volunteers</li>
              <li>Be franchised by local patriots</li>
            </ul>
            <div className="text-center mt-8">
              <CountryDropdown />
            </div>
          </div>
        </div>
      </section>

      {/* SEO Command Section */}
      <section
        className="relative py-28 px-4 sm:px-6 text-center bg-gradient-to-br from-[#b08968] via-[#5e3d2b] to-[#3e2c23]"
        id="seo-command"
      >
        <div className="relative z-10 max-w-6xl mx-auto text-[#FFFADD]">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-fortyTwo mb-6 border-b-4 border-[#A9744F] inline-block pb-2 p-3 shadow-md">
            SEO CHAMPIONS TROPHY
          </h2>

          <p className="text-lg sm:text-xl md:text-2xl leading-relaxed max-w-4xl mx-auto mb-8 text-[#fff1cf]">
            This is also an SEO battlefield.
            <br />
            We are inviting SEO professionals from across Pakistan to:
          </p>

          <div className="bg-[#FFF5D1] text-[#2e1c12] rounded-xl px-8 py-10 shadow-xl text-left max-w-4xl mx-auto mb-10">
            <ul className="list-disc list-inside text-lg space-y-3">
              <li>Build page authority</li>
              <li>Dominate global Google searches</li>
              <li>Rank national content above enemy propaganda</li>
              <li>Track, monitor, and outmaneuver digital threats</li>
            </ul>
          </div>

          <h2 className="text-3xl sm:text-4xl md:text-5xl font-fortyTwo mb-6 border-b-4 border-[#A9744F] inline-block pb-2 p-3 shadow-md text-[#fff9dc]">
            CALL TO ACTION
          </h2>

          <p className="text-lg sm:text-xl md:text-2xl leading-relaxed max-w-4xl mx-auto text-[#fbeec1]">
            This is not a campaign. This is a digital war.
            <br />
            Choose your front. Hold your ground.
            <br />
            Push back with truth, pride, and purpose.
          </p>
        </div>
      </section>
    </div>
  );
};

export default MissionPage;
